module.exports = __webpack_public_path__ + "static/media/icono-transporte.f973e49d.svg";